import React, { FC } from 'react';
import { Helmet, HelmetData } from 'react-helmet-async';

interface HeadProps {
    children?: React.ReactNode;
    title: string;
}
const helmetData = new HelmetData({});

const Head: FC<HeadProps> = ({ children, title }) => {
    return (
        <>
            <Helmet
                helmetData={helmetData}
                title={title}
                defaultTitle={title}
            >
                {children}
            </Helmet>
        </>
    );
};

export default Head;